module.exports = __webpack_public_path__ + "img/IT0001903345813.12f46f1e.png";